module.exports = __webpack_public_path__ + "static/img/2.5cf6b8ad.png";